import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M44.2616 69.4588C44.4894 66.3814 47.0745 64 50.1872 64H150.053C153.166 64 155.751 66.3814 155.979 69.4588L163.107 165.732C163.317 168.577 161.046 171 158.169 171H42.0717C39.1944 171 36.9231 168.577 37.1337 165.732L44.2616 69.4588Z",
      fill: "#C8B192",
      style: {"fill":"#C8B192"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M149.69 61C154.067 61 157.703 64.4067 158.024 68.8088L165.1 166.022C165.413 170.33 162.031 174 157.746 174H42.4931C38.2087 174 34.8268 170.33 35.1403 166.022L42.2166 68.8088C42.537 64.4068 46.1721 61.0002 50.5495 61H149.69ZM50.5495 65.9561C48.7471 65.9563 47.2504 67.3593 47.1184 69.1718L40.0421 166.385C39.9378 167.821 41.0651 169.044 42.4931 169.044H157.746C159.174 169.044 160.301 167.821 160.197 166.385L153.122 69.1718C152.99 67.3592 151.492 65.9561 149.69 65.9561H50.5495Z",
      fill: "#461F18",
      style: {"fill":"#461F18"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M100.342 21C117.477 21 131.368 34.8909 131.368 52.0264V74.2324C133.403 75.1661 134.815 77.2205 134.815 79.6055C134.815 82.8693 132.17 85.5155 128.906 85.5156C125.642 85.5156 122.996 82.8694 122.996 79.6055C122.996 77.2207 124.409 75.1662 126.443 74.2324V52.0264C126.443 37.6108 114.757 25.9248 100.342 25.9248C85.9262 25.9248 74.2403 37.6108 74.2402 52.0264V74.2324C76.2744 75.1662 77.6874 77.2207 77.6875 79.6055C77.6875 82.8694 75.0413 85.5156 71.7773 85.5156C68.5135 85.5156 65.8672 82.8694 65.8672 79.6055C65.8673 77.2205 67.281 75.1661 69.3154 74.2324V52.0264C69.3155 34.8908 83.2063 21 100.342 21Z",
      fill: "#461F18",
      style: {"fill":"#461F18"}
    }, null, -1)
  ])))
}
export default { render: render }